// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_KwD","cls2":"Header-cls2_2yt Header-cls1_KwD"};